<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getFinanceUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">财务账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateFinanceUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getFinanceUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <FinanceUserEdit ref="financeUserModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateRender } from '@/libs/tableRowTimeRender';
import FinanceUserEdit from './finance-user-edit';
import { getFinanceUserList } from '@/api/modules/account-management/finance-user-management';

export default {
    name: 'FinanceUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        FinanceUserEdit
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '姓名', key: 'userFinanceName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '手机号码', key: 'userFinancePhone', align: 'center' },
                    {
                        title: '是否主账号', key: 'isPrimaryAccount', align: 'center', render: (h, params) => {
                            return h('div', [
                                h('span', {}, params.row.isPrimaryAccount==1?"是":"否")
                            ]);
                        }
                    },
                    {
                        title: '审核',
                        key: 'userFinanceApproval',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userFinanceApproval))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'userFinanceCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.userFinanceCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateFinanceUser(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userFinanceName', sql: 'like' },
                    { label: '审核状态', type: 'Select', name: 'userFinanceApproval', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }] }

                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getFinanceUserTableRecords();
    },
    methods: {
        getFinanceUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getFinanceUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateFinanceUser() {
            this.$refs.financeUserModal.showModal();
            // this.$router.push({
            //     name: 'finance-user-edit',
            //     query: {
            //         userFinanceLoginUuid: ''
            //     }
            // });
        },
        onUpdateFinanceUser(financeUserRow) {
            this.$refs.financeUserModal.showModal(financeUserRow.userFinanceLoginUuid);

            // this.$router.push({
            //     name: 'finance-user-edit',
            //     query: {
            //         userFinanceLoginUuid: financeUserRow.userFinanceLoginUuid
            //     }
            // });
        }
    }
};
</script>

<style scoped>
</style>
